export const data = [

  {
    category: 'אביזרי אמבטיה',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'אינסטלציה',
    imageUrl:"https://www.yerushalmy-son.co.il/tn_Cat_485513_811.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'דבקים',
    imageUrl:"https://www.yerushalmy-son.co.il/tn_Cat_485513_811.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'חגים',
    imageUrl:"https://edu.gov.il/noar/minhal/SiteCollectionImages/holidays-lobby/hagim.png",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'חוטים',
    imageUrl:"https://www.yerushalmy-son.co.il/tn_Cat_485513_811.jpg",
    totalAmountProducts: 900,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'חומרי איטום',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 2700,
    productsPerCategort: 35,

    netWorthStore: 9066.66
  },
  {
    category: 'חומרי בנין',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 1350,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'חומרי ניקיון',
    imageUrl:"https://www.cleanshiny.co.il/wp-content/uploads/2014/02/%D7%90%D7%A1%D7%A4%D7%A7%D7%AA-%D7%97%D7%95%D7%9E%D7%A8%D7%99-%D7%A0%D7%99%D7%A7%D7%99%D7%95%D7%9F.jpg",
    totalAmountProducts: 550,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'חקלאות',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 1975,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'ידיות',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 7500,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'כימיקלים',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 100,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'כלי בית',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'כלי כתיבה',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'כלי מטבח',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'כלי ניקוי',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'כלי עבודה',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'כלי עבודה חשמליים',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'מוצרי חשמל',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'מנעולים',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'מתנות',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'נורות',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'סוללות',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 35,
    netWorthStore: 9066.66
  },
  {
    category: 'פנסים',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 103,
    productsPerCategort: 18,
    netWorthStore: 2418.9
  },
  {
    category: 'פרזול',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 415,
    productsPerCategort: 172,
    netWorthStore: 25410.65
  },
  {
    category: 'צבע',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 967,
    productsPerCategort: 57,
    netWorthStore: 15986.57
  },
  {
    category: 'צורכי חשמל',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 2189,
    productsPerCategort: 35,
    netWorthStore: 16676.14
  },
  {
    category: 'קלטות ונגנים',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 253,
    productsPerCategort: 38,
    netWorthStore: 7027.9
  },
  {
    category: 'שונות',
    imageUrl:"https://hamat.co.il/uploads/families/34-image.jpg",
    totalAmountProducts: 2453,
    productsPerCategort: 149,
    netWorthStore: 22991.23
  },

]